import React from 'react';

const AboutUs = () => {
  return (
    <div className="bg-white py-16 font-playfair">

      {/* Company Overview */}
      <section className="flex flex-col lg:flex-row justify-between px-6 xl::px-12 mb-20 items-center">
        <div className="text-center xl:text-left">
          <h1 className="text-4xl lg:text-6xl xl:text-8xl 2xl:text-9xl font-bold text-black">Who We Are</h1>
          {/* text-[#2C3E50] */}
          <p className="mt-4 lg:text-2xl xl:text-3xl text-lg text-gray-600">
            Know more about our company and what we stand for.
          </p>
        </div>
        <div className="w-full xl:w-1/2 pr-0 md:pr-8 mt-8 md:mt-0">
          <h2 className="text-3xl lg:text-6xl xl:text-8xl 2xl:text-9xl font-bold text-black mb-4 text-center mt-6">About Us</h2>
          <p className="text-lg lg:text-2xl xl:text-3xl text-gray-600 mb-4 text-justify mt-8">
            DSGO Solutions is one of the leading suppliers of tailored refrigeration equipment solutions for small, medium, and large stores. We supply high-quality refrigerated solutions across all sectors, from supermarkets and cafés to hotels and restaurants, and the wider hospitality industry. Our equipment is designed to optimize the display and conservation of food to maximize quality and sales.
          </p>
          <p className="text-lg lg:text-2xl xl:text-3xl text-gray-600 text-justify">
            Our philosophy is to evolve by recognizing market trends in food sales and display, using cutting-edge technologies and materials to meet performance demands, without compromising on aesthetics. Our ability to personalize and customize our solutions has made DSGO Solutions a market leader in technological innovation.
          </p>
        </div>
      </section>

      {/* Image Section */}
      <div
        className="relative w-full bg-cover h-[400px] md:h-[500px]  rounded-2xl"
        style={{ backgroundImage: "url('images/about11.png')" }}
      >
        <div className="absolute inset-0"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
        </div>
      </div>

      {/* Inspirational Quote and Image */}
      <section className="flex flex-col md:flex-row justify-between px-6 md:px-12 lg:m-12 xl:m-28 items-center mt-8">
        <div className="w-full md:w-1/2 pr-0 md:pr-8">
          <p className="text-lg lg:text-2xl xl:text-3xl text-justify text-black mb-4">
          "We value every moment you spend with us. Our goal is to bring you quality and satisfaction in everything we offer. 
          Your happiness drives our passion, and we are committed to continuously improving to meet your needs.
           We believe in building long-lasting relationships with our customers and providing exceptional experiences.
            Thank you for choosing us and for being a part of our journey!"

          </p>
        </div>
        <div className="w-full md:w-1/2 justify-center mt-8 md:mt-0">
          <img
            src="images/about22.png"
            alt="Refrigeration Equipment"
            className="w-full h-[500px] rounded-lg shadow-lg object-cover"
          />
        </div>
      </section>

      {/* Team Section */}
      {/* <div className="flex flex-col md:flex-row items-center justify-between gap-12 p-8 bg-gray-100">
        <div className="w-full md:w-1/2 flex flex-col items-center">
          <div className="grid grid-cols-2 gap-4">
            <img
              src="images/about3.png"
              alt="Team member 1"
              className="w-60 h-60 object-cover rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300"
            />
            <img
              src="images/team.png"
              alt="Team member 2"
              className="w-60 h-60 object-cover rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300"
            />
          </div>
          <div className="mt-4">
            <img
              src="images/team1.png"
              alt="Team member 3"
              className="w-60 h-60 object-cover rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300"
            />
          </div>
        </div>

        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-3xl lg:text-6xl xl:text-7xl font-bold text-gray-800 mb-4 text-center">Meet Our Team</h2>
          <p className="text-gray-600 text-lg lg:text-2xl xl:text-3xl mb-4">
            Our team is dedicated to delivering high-quality solutions with innovation and passion. We believe in teamwork and strive for excellence in every project.
          </p>
          <p className="text-gray-600 text-lg lg:text-2xl xl:text-3xl">
            Together, we bring diverse experiences and unique perspectives to create impactful solutions for our clients.
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default AboutUs;
